import Slider from "../../components/slider/Slider";
import React, { useEffect, useState } from "react";
import { getRetiredSliderRequest } from "../../services/sliders";
import { getRetiredNewsList } from "../../services/news/news.service";
import Heading from "../../components/heading/heading";
import { Link } from "react-router-dom";
import styles from "./Retired.module.css";
import "react-tabs/style/react-tabs.css";
import Title from "../../components/title";
import NewsBar from "../../components/product/NewsBar";

const Retired = () => {
  let [sliders, setSliders] = useState([]);
  let [news, setNews] = useState([]);

  useEffect(() => {
    getRetiredSliderRequest().then(({ data }) => {
      setSliders((data && data.data) || []);
    });
    getRetiredNewsList().then(({ data }) => {
      setNews((data && data.data) || []);
    });
  }, []);
  return (
    <>
      <Title title={"بازنشتگان"} />
      <div>
        {sliders && sliders.length > 0 ? (
          <>
            <Slider items={sliders} />
          </>
        ) : (
          <div className="loading-wrapper">
            <img
              src={"../../../assets/image/loading.svg"}
              alt={"در حال بار گذاری"}
            />
          </div>
        )}
        <div className={"clearfix"}></div>
        <div className={`${styles.retiredContainer} ${"container"}`}>
          <Heading title={"اخبار بازنشستگان"} />
          <div className="row">
            {news && news.length > 0 ? (
              news.map((item, key) => {
                return (
                  <div className="col-xs-12 col-md-6 pull-right">
                    <NewsBar key={key + "-product-bar"} news={item} />
                  </div>
                );
              })
            ) : (
              <div className="loading-wrapper">
                <img
                  src={"../../../assets/image/loading.svg"}
                  alt={"در حال بار گذاری"}
                />
              </div>
            )}
          </div>
          <Link to={"/retired/news/list"} id={styles.loadMore}>
            <i id="loadMore" className={"fa fa-plus"}></i> بیشتر
          </Link>
        </div>
      </div>
    </>
  );
};

export default Retired;
